import { type ChangeEvent, useCallback, useState } from 'react';

import Icon from 'components/Icon/Icon';
import { AUTH_PAGES, useAuthRedirects } from 'utils/authRedirects';
import pushToDataLayer, { btag } from 'utils/dataLayer';

import styles from './WelcomeBanner.module.scss';

const BannerInput = () => {
  const [email, setEmail] = useState('');
  const { redirectToAuthPage } = useAuthRedirects();

  const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const onRedirectHandler = useCallback(() => {
    pushToDataLayer('main_email_CTA_click', btag);

    redirectToAuthPage(AUTH_PAGES.signUp, {
      email,
    });
  }, [redirectToAuthPage, email]);

  return (
    <div className={styles['input-wrapper']}>
      <input
        className={styles.input}
        type="text"
        onChange={onChangeHandler}
        value={email}
        placeholder="Enter your email"
      />
      <button
        className={styles.button}
        type="button"
        onClick={onRedirectHandler}
      >
        <Icon name="arrow-right.bold" />
      </button>
    </div>
  );
};

export default BannerInput;
